
































































































































// import Vue from 'vue'
// import Component from 'vue-class-component'

import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop, Watch } from 'vue-property-decorator'
import { Getter, Mutation, Action } from 'vuex-class'


import DigitalCurrency1DigitalCurrencySymbol from '../../../../html-components-type-1-basic/basic-type-2-digital-currency/digital-currency-1-digital-currency-symbol.vue'
import DigitalCurrency2SendPaymentButton from '../../../../html-components-type-1-basic/basic-type-2-digital-currency/digital-currency-2-send-payment-button.vue'
import DigitalCurrency6AccountUserProfilePicture from '../../../../html-components-type-1-basic/basic-type-2-digital-currency/digital-currency-6-account-user-profile-picture.vue'
import DigitalCurrency7AccountBalanceNumberWithIcon from '../../../../html-components-type-1-basic/basic-type-2-digital-currency/digital-currency-7-account-balance-number-with-icon.vue'
import DigitalCurrency9AccountShortIntroductionButton from '../../../../html-components-type-1-basic/basic-type-2-digital-currency/digital-currency-9-account-short-introduction-button.vue'
import DigitalCurrency11QrCodeScannerButton from '../../../../html-components-type-1-basic/basic-type-2-digital-currency/digital-currency-11-qr-code-scanner-button.vue'
import DigitalCurrency15AccountSettingsButton from '../../../../html-components-type-1-basic/basic-type-2-digital-currency/digital-currency-15-account-settings-button.vue'
import DigitalCurrency20AnimatedCurrencyLabel from '../../../../html-components-type-1-basic/basic-type-2-digital-currency/digital-currency-20-animated-currency-label.vue'

import Groups1AddToGroupButton from '../../../../html-components-type-1-basic/basic-type-5-groups/groups-1-add-to-group-button.vue'

import { projectVariables } from '../../../../../../../../../../service-for-environment-variables/environment-variables-type-1-general-variables/general-variables-type-1-project-variables/project-variables-1-introduction'

import { BASIC_DESCRIPTION } from '../../../../../../../../../../service-for-game-codebase/game-codebase-type-1-app/app-type-2-digital-currency-account/digital-currency-account-type-3-constants/constants-1-account-description'

import { GROUP_ITEM_TYPE_ACCOUNT } from '../../../../../../../../../../service-for-game-codebase/game-codebase-type-1-app/app-type-2-digital-currency-account/digital-currency-account-type-2-data-structures/data-structures-type-5-account-groups/account-groups-1'

import {
  universalBasicIncomeTransaction
} from '../../../../../../../../../../service-for-environment-variables/environment-variables-type-1-general-variables/general-variables-type-1-project-variables/project-variables-4-digital-currency'

import { getTimeUntilMillisecondDurationReached } from '../../../../html-components-type-1-basic/basic-type-2-digital-currency/service-for-helper-algorithms/helper-algorithms-4-get-time-until-millisecond-duration-reached'

import { getDigitalCurrencyAmountWithCommaSeparatedValue } from '../../../../html-components-type-1-basic/basic-type-2-digital-currency/service-for-helper-algorithms/helper-algorithms-2-get-digital-currency-amount-with-comma-separated-value'

import { createDigitalCurrencyFountainParticleEffectFunctionAlgorithm } from '../../../../html-components-type-1-basic/basic-type-2-digital-currency/service-for-helper-algorithms/helper-algorithms-5-create-digital-currency-fountain-particle-effect'

import { getUTCDate1 } from '../../../../../../../../../../service-for-game-codebase/game-codebase-type-1-app/app-type-1-general/general-type-1-algorithms/algorithms-type-3-get-utc-date/get-utc-date-1'
import { NUMBER_OF_MILLISECONDS_IN_A_MINUTE } from '../../../../../../../../../../service-for-game-codebase/game-codebase-type-1-app/app-type-1-general/general-type-3-constants/constants-3-time'

// import { getLocalDateFromUTCDate1 } from '../../../../../../../../../../service-for-game-codebase/game-codebase-type-1-app/app-type-1-general/general-type-1-algorithms/algorithms-type-8-get-local-date-from-utc-date/get-local-date-from-utc-date-1'

const namespace = 'digitalCurrency'



@Component({
  components: {
    DigitalCurrency1DigitalCurrencySymbol,
    DigitalCurrency2SendPaymentButton,
    DigitalCurrency6AccountUserProfilePicture,
    DigitalCurrency7AccountBalanceNumberWithIcon,
    DigitalCurrency9AccountShortIntroductionButton,
    DigitalCurrency11QrCodeScannerButton,
    DigitalCurrency15AccountSettingsButton,
    DigitalCurrency20AnimatedCurrencyLabel,
    Groups1AddToGroupButton
  }
})
class AccountPageHeader extends Vue {
  @Prop({ default: false }) isUsedForWebComponent?: boolean

  @Prop({ default: '' }) accountId?: string
  @Prop({ default: false }) isPublicAccountViewing?: boolean

  @Prop({ default: false }) showInNav?: boolean

  @Getter('getActiveDigitalCurrencyAccount', { namespace }) getActiveDigitalCurrencyAccount?: any

  @Getter('getDigitalCurrencyAccount', { namespace }) getDigitalCurrencyAccount: any
  @Getter('getDigitalCurrencyAccountDescription', { namespace }) getDigitalCurrencyAccountDescription?: any

  // @Getter('getYourActiveDigitalCurrencyAccount', { namespace }) getYourActiveDigitalCurrencyAccount: any
  // @Getter('getAccountPageCurrentAccount', { namespace }) getAccountPageCurrentAccount: any


  @Mutation('toggleShowCreateTransactionDialog') toggleShowCreateTransactionDialog: any
  @Mutation('toggleShowQRCodeDialog') toggleShowQRCodeDialog: any

  @Mutation('toggleShowSettingsDialog') toggleShowSettingsDialog: any

  @Action('serviceInformation1GetServiceInformationByDaemonStatus') serviceInformation1GetServiceInformationByDaemonStatus?: any

  PROJECT_WEBSITE_URL: string = projectVariables.projectWebsiteUrlTable.userServiceWebsiteList[0]
  digitalCurrencyName = projectVariables.digitalCurrencyName

  GROUP_ITEM_TYPE_ACCOUNT: string = GROUP_ITEM_TYPE_ACCOUNT

  percentTimeRemaining: number = 0
  timeRemainingUntilUniversalBasicIncomeDistribution: string = ''
  setIntervalUniversalBasicIncomeTimerId: any = null

  universalBasicIncomeAmountDistributed: number = universalBasicIncomeTransaction.transactionCurrencyAmount
  millisecondDelayBetweenUniversalBasicIncomeDistribution: number = universalBasicIncomeTransaction.millisecondRecurringDelay

  currentRouteName: string = ''

  showUniversalBasicIncomeNotification: boolean = false
  showUniversalBasicIncomeAnimationScene: boolean = false

  millisecondDelayToHideUniversalBasicIncomeNotification: number = 15 * 1000 // 15 seconds
  millisecondDelayToHideUniversalBasicIncomeAnimationScene: number = 2 * 1000 // 2 seconds

  millisecondTimeLeftToHideNotification: number = 0
  startUniversalBasicIncomeAnimationSceneRenderLoopFunction: Function = () => { /* */ }

  isActiveServiceDaemon: boolean = true
  isActiveServiceDaemonIntervalId: any = null

  getDigitalCurrencyAmountWithCommaSeparatedValue = getDigitalCurrencyAmountWithCommaSeparatedValue


  @Watch('$route') routeChange () {
    this.currentRouteName = this.$router.currentRoute.name || ''
  }

  @Watch('percentTimeRemaining') updateShowUniversalBasicIncomeNotification () {

    if (!this.isActiveServiceDaemon) {
      return
    }

    const isTimeToShowUniversalBasicIncomeNotification = !this.showUniversalBasicIncomeNotification && (this.percentTimeRemaining >= 99 || this.percentTimeRemaining <= 1)
    if (!isTimeToShowUniversalBasicIncomeNotification) {
      return
    }

    this.showUniversalBasicIncomeNotification = true
    this.showUniversalBasicIncomeAnimationScene = true

    this.startUniversalBasicIncomeAnimationSceneRenderLoopFunction()

    this.millisecondTimeLeftToHideNotification = this.millisecondDelayToHideUniversalBasicIncomeNotification

    const millisecondTimeToHideNotificationInterval = setInterval(() => {
      this.millisecondTimeLeftToHideNotification -= 1000
    }, 1000)

    // Hide the universal basic income notification
    setTimeout(() => {
      clearInterval(millisecondTimeToHideNotificationInterval)
      this.hideUniversalBasicIncomeNotification()
      this.showUniversalBasicIncomeNotification = false
    }, this.millisecondDelayToHideUniversalBasicIncomeNotification)
  }

  hideUniversalBasicIncomeNotification () {
    this.showUniversalBasicIncomeNotification = false

    setTimeout(() => {
      this.showUniversalBasicIncomeAnimationScene = false
    }, this.millisecondDelayToHideUniversalBasicIncomeAnimationScene)
  }

  startTimerUntilUniversalBasicIncomeDistribution () {
    const self = this

    const ubiStartDate = new Date(universalBasicIncomeTransaction.dateTransactionCreated!)
    const ubiMillisecondDelayBetweenDistribution = universalBasicIncomeTransaction.millisecondRecurringDelay || 0

    this.setIntervalUniversalBasicIncomeTimerId = setInterval(function () {

      if (!self.isActiveServiceDaemon) {
        self.timeRemainingUntilUniversalBasicIncomeDistribution = '??'
        return
      }
      const delayTimeToStart = getUTCDate1(new Date()).getTime() - ubiStartDate.getTime()
      const isPastStartDate = delayTimeToStart > 0

      if (!isPastStartDate) {
        return
      }

      const delayTimeToStartAtPreviousInterval = ((delayTimeToStart / ubiMillisecondDelayBetweenDistribution) % 1) * ubiMillisecondDelayBetweenDistribution
      const delayTimeToStartAtNextInterval = (1 - ((delayTimeToStart / ubiMillisecondDelayBetweenDistribution) % 1)) * ubiMillisecondDelayBetweenDistribution
      const millisecondsRemainingUntilDistribution = isPastStartDate ? delayTimeToStartAtPreviousInterval : Math.abs(delayTimeToStart)

      self.percentTimeRemaining = Math.floor((millisecondsRemainingUntilDistribution / ubiMillisecondDelayBetweenDistribution) * 100)
      self.timeRemainingUntilUniversalBasicIncomeDistribution = getTimeUntilMillisecondDurationReached(Math.floor(delayTimeToStartAtNextInterval))
    }, 1000) as any
  }

  get universalBasicIncomeDistributionInterval (): string {
    const milliseconDuration = universalBasicIncomeTransaction.millisecondRecurringDelay
    return getTimeUntilMillisecondDurationReached(milliseconDuration || 0)
  }

  get selectedAccount () {
    const account = this.getDigitalCurrencyAccount(this.accountId)
    return account
  }

  get selectedAccountBasicDescription () {
    const accountDescription = this.getDigitalCurrencyAccountDescription(this.accountId, BASIC_DESCRIPTION)
    return accountDescription
  }

  get accountUsernameWebsiteAddress () {
    return `${location.origin}/${this.selectedAccount.accountUsername}`
  }

  async mounted () {
    this.currentRouteName = this.$router.currentRoute.name || ''
    this.startTimerUntilUniversalBasicIncomeDistribution()

    this.addUniversalBasicIncomeAnimationScene()
    await this.initializeGetIsActiveServiceDaemon()
  }

  destroyed () {
    clearInterval(this.setIntervalUniversalBasicIncomeTimerId)
    clearInterval(this.isActiveServiceDaemonIntervalId)
  }

  async initializeGetIsActiveServiceDaemon () {
    const daemonStatus = await this.serviceInformation1GetServiceInformationByDaemonStatus('daemon-1')
    this.isActiveServiceDaemon = daemonStatus ? daemonStatus.isActive : false

    if (this.isActiveServiceDaemonIntervalId) {
      clearInterval(this.isActiveServiceDaemonIntervalId)
    }

    this.isActiveServiceDaemonIntervalId = setInterval(async () => {
      const daemonStatus = await this.serviceInformation1GetServiceInformationByDaemonStatus('daemon-1')
      this.isActiveServiceDaemon = daemonStatus ? daemonStatus.isActive : false
    }, 1 * NUMBER_OF_MILLISECONDS_IN_A_MINUTE)
  }

  addUniversalBasicIncomeAnimationScene () {
    const animationSceneContainer = this.$refs['universalBasicIncomeAnimationScene'] as HTMLElement
    const digitalCurrencySymbolImageIconUrl = projectVariables.digitalCurrencySymbolImageIconUrl
    const stopRenderLoopCallbackFunction = () => { return !this.showUniversalBasicIncomeAnimationScene }
    const { startRenderLoop } = createDigitalCurrencyFountainParticleEffectFunctionAlgorithm.function(animationSceneContainer, digitalCurrencySymbolImageIconUrl, stopRenderLoopCallbackFunction)
    this.startUniversalBasicIncomeAnimationSceneRenderLoopFunction = startRenderLoop
  }

}

export default AccountPageHeader
